import { HttpErrorResponse } from "@angular/common/http";
import { CASH_TITLE_CREATED_BY, CASH_TITLE_MOVEMENT_TYPE, CreateCashTitleMovimentationParamethers } from "../interface/cash-log-interfaces";
import { CashTitle, TITLE_STATUS } from "../interface/cash-title";
import CashTitleMovementation from "../interface/cash-title-movementation";

export default class MkgCashTitleLog implements CashTitleMovementation {

  readonly id?: string;

  balance?: number;
  clientId?: string;
  createdBy?: CASH_TITLE_CREATED_BY;
  creationCompany: string;
  invoiceId?: string;
  invoiceNumber?: number;
  movementType?: CASH_TITLE_MOVEMENT_TYPE;
  orderId?: string;
  osId?: string;
  statusInTheMovement?: TITLE_STATUS;
  suppliedId?: string;
  targetCompany: string;
  titleId: string;
  totalValue?: number;
  userId?: string;
  value?: number;
  valueChanged?: number;
  discount: number;
  fees: number;
  penaltyFee: number;
  rate: number;
  valueBeforeUpdate: number;
  balanceBeforeUpdate: number;
  titlesUsedInRenegociation?: string[];
  titleErro?: string;
  triggerFromAdmCardCreation: string;
  advancesUsed?: string[];
  advanceTargetId?: string;
  Balance: number;

  /**
   * @param data The data of cash title movimentation
   * @param type Tells to the constructor if is a creation or a already existent movimentation, if type is equal 2 just assign the object
   */
  constructor(data: CreateCashTitleMovimentationParamethers | CashTitleMovementation, type: 1 | 2) {
    if (type === 1) {
      const {
        title,
        isSupplier,
        origin,
        creationCompany,
        targetCompany,
        movementType,
        userId,
        invoiceId,
        invoiceNumber,
        valueChanged = 0,
        titleBeforeChanges,
        osId,
        orderId,
        renegociationTitlesId,
        titleErro,
        triggerFromAdmCardCreation,
        advancesUsed,
        advanceTargetId
      } = data as CreateCashTitleMovimentationParamethers;
  
      this.balance = title?.balance;

      const clientOrSupplierId = title["supplier_clientId"] ?? title["supplier_client"]?.["_id"] ?? title["supplier_client"]?.["id"];

      if (!!clientOrSupplierId) {
        if (isSupplier) {
          this.suppliedId = clientOrSupplierId;
        } else if (isSupplier !== null && isSupplier !== undefined) {
          this.clientId = clientOrSupplierId;
        }
      }

      if ((title?.invoiceNumber !== null && title?.invoiceNumber !== undefined) || (invoiceNumber !== null && invoiceNumber !== undefined)) {
        this.invoiceNumber = +title?.invoiceNumber;
      }

      if (renegociationTitlesId?.length) {
        this.titlesUsedInRenegociation = renegociationTitlesId;
      }

      if (title?._id) {
        this.titleId = title?._id;
      }

      if (titleErro) {
        this.titleErro = this._formatError(titleErro);
      }

      this.createdBy = origin;
      this.creationCompany = creationCompany;
      this.targetCompany = targetCompany;
      this.invoiceId = invoiceId;
      this.movementType = movementType;
      this.orderId = orderId ?? title?.orderId;
      this.osId = osId ?? title?.idOS;
      this.statusInTheMovement = title?.status;
      this.totalValue = (title?.value ?? 0) + (((title?.penaltyFee ?? 0) + (title?.fees ?? 0)) - ((title?.discount ?? 0) + (title?.rate ?? 0)));
      this.userId = userId;
      this.value = title?.value;
      this.valueChanged = valueChanged ?? 0;
      this.discount = title?.discount ?? 0;
      this.fees = title?.fees ?? 0;
      this.penaltyFee = title?.penaltyFee ?? 0;
      this.rate = title?.rate ?? 0;
      this.valueBeforeUpdate = titleBeforeChanges?.value;
      this.balanceBeforeUpdate = titleBeforeChanges?.balance;
      this.triggerFromAdmCardCreation = triggerFromAdmCardCreation;
      this.advancesUsed = advancesUsed ?? [];
      this.advanceTargetId = advanceTargetId;
      this.Balance = title.balance;
      
    } else {
      Object.assign(this, data);
    }
  }

  private _formatError(error: unknown): string {
    let errorAsString: string;

    if (error instanceof Error) {
      const stackLines = error.stack?.split('\n') || [];
      const limitedStack = stackLines.slice(0, 2).join('\n'); // message + first 3 frames

      errorAsString = JSON.stringify({
        message: error.message,
        name: error.name,
        stack: limitedStack,
      });
    } else if (error instanceof HttpErrorResponse) {
      errorAsString = JSON.stringify({
        message: error.message,
        name: error.name,
        error: error.error,
        url: error.url
      });
    } else {
      errorAsString = JSON.stringify(error);
    }

    return errorAsString.slice(0, 500);
  }
}